const actionTypeIdentifier = 'F910B160-11D0-4C88-8D6E-adfgd2343'; // to be updated

//location form actions
export const setCountryOptions = `SET-NEW-CIRCUIT-COUNTRY-OPTIONS-${actionTypeIdentifier}`;
export const setAddressOptions = `SET-NEW-CIRCUIT-ADDRESS-OPTIONS-${actionTypeIdentifier}`;
//subscription form actions
export const setCategoryOptions = `SET-NEW-CIRCUIT-CATEGORY-OPTIONS-${actionTypeIdentifier}`;
export const setCircuitTypeOptions = `SET-NEW-CIRCUIT-CIRCUIT-TYPE-OPTIONS-${actionTypeIdentifier}`;
export const setSubCircuitTypeOptions = `SET-NEW-CIRCUIT-SUB-CIRCUIT-TYPE-OPTIONS-${actionTypeIdentifier}`;
export const setPrimarySecondaryOptions = `SET-NEW-CIRCUIT-PRIMARY-SECONDARY-OPTIONS-${actionTypeIdentifier}`;
export const setDefaultPrimarySecondary = `SET-NEW-CIRCUIT-DEFAULT-PRIMARY-SECONDARY-${actionTypeIdentifier}`;
export const setPurposeOfUseOptions = `SET-NEW-CIRCUIT-PURPOSE-OF-USE-${actionTypeIdentifier}`;
export const setVendorOptions = `SET-NEW-CIRCUIT-FORM-VENDOR-OPTIONS-${actionTypeIdentifier}`;
export const setVendorDetails = `SET-NEW-CIRCUIT-FORM-VENDOR-DETAILS-${actionTypeIdentifier}`;
//business form actions
//export const setPurposeOfUseOptions = `SET-NEW-MOBILE-PURPOSE-OF-USE-OPTIONS-${actionTypeIdentifier}`;
export const setFormSubmitted = `SET-NEW-CIRCUIT-FORM-SUBMITTED-${actionTypeIdentifier}`;

export const wirelineLocationModelA = {
    countryCode: ''
    , country: ''
    , billingAddress: ''
    , billingAddressId: null
    , locationAddressId: ''
    , locationAddressPTPId: ''
    , isServiceLocation: true
    , isServiceLocationPTP: true
    , demarcLocation: ''
    , demarcLocationPTP: ''
}

export const wirelineSubscriptionModelA = {
    vendorDetailId: ''
    , itemUseId: 0
    , circuitTypeId: 0
    , subCircuitTypeId: 0
    , primarySecondaryId: 0
    , btnId: 0
    , mrc: 0
    , nrc: 0
    , mrc2: 0
    , nrc2: 0
    , totalCost: 0
}

export const wirelineBusinessModelA = {
    wireLineApproverId: 0
    , wireLineGlCodeId: 0
    , wireLineCostCenterId: 0
    , purposeOfUseId: 0
    , businessJustification: ''
    , additionalInformation: ''
    , localContactEmail: ''
    , localContactFullName: ''
    , localContactPhone: ''
    , altLocalContactEmail: ''
    , altLocalContactFullName: ''
    , altLocalContactPhone: ''
    , companyCode: ''
    , needByDate: ''
    , expediteRequest: false
}